import { LoginCallback } from '@okta/okta-react';
import { RouteObject } from 'react-router-dom';
import { Home } from '@/pages/Home';
import { Fixture } from '@/pages/Fixture';
import { App } from '@/App';
import { ROUTE_PATHS } from '@/router/constants';
import { AuthProvider } from '@/contexts/auth';

export const routes: RouteObject[] = [
  {
    path: ROUTE_PATHS.OKTA_LOGIN_CALLBACK,
    element: (
      <AuthProvider>
        <LoginCallback />
      </AuthProvider>
    ),
  },
  {
    path: ROUTE_PATHS.HOME,
    element: <App />,
    children: [
      {
        path: ROUTE_PATHS.FIXTURE,
        element: <Fixture />,
      },
      { path: '', element: <Home /> },
    ],
  },
];
